import * as React from 'react';

function IconSystemLoading(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.167a.917.917 0 00-.917.916v2.535a.917.917 0 001.834 0V2.083A.916.916 0 0010 1.167z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.547 6.842a.914.914 0 001.565-.648.917.917 0 00-.269-.648L5.05 3.754A.918.918 0 003.754 5.05l1.792 1.792z"
        fill="currentColor"
        fillOpacity={0.16}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.535 10a.917.917 0 00-.917-.917H2.083a.917.917 0 000 1.834h2.535A.917.917 0 005.535 10z"
        fill="currentColor"
        fillOpacity={0.32}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.547 13.158l-1.793 1.791a.918.918 0 001.297 1.297l1.792-1.792a.917.917 0 00-1.296-1.296zM10 14.465a.917.917 0 00-.917.917v2.535a.916.916 0 001.834 0v-2.535a.917.917 0 00-.917-.917z"
        fill="currentColor"
        fillOpacity={0.56}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.453 13.158a.916.916 0 10-1.296 1.296l1.792 1.792a.913.913 0 001.297 0 .915.915 0 000-1.297l-1.792-1.791zM17.917 9.083h-2.535a.917.917 0 000 1.834h2.535a.917.917 0 000-1.834zM13.805 7.112c.234 0 .47-.09.648-.269l1.793-1.792a.917.917 0 00-1.297-1.297l-1.791 1.792a.918.918 0 00.647 1.566z"
        fill="currentColor"
        fillOpacity={0.72}
      />
    </svg>
  );
}

const MemoIconSystemLoading = React.memo(IconSystemLoading);
export default MemoIconSystemLoading;
